import { navigate, useLocation } from '@reach/router'
import { ReactNode } from 'react'
import { Modal } from 'react-responsive-modal'

type SimpleModalProps = {
    children?: ReactNode
    open: boolean
    onClose: () => void
    showCloseIcon?: boolean
    closeOnOverlayClick?: boolean
    closeOnEsc?: boolean
}

const SimpleModal: React.FC<SimpleModalProps> = ({ children, open, onClose, ...newProps }) => {
    const location = useLocation()

    const handleClose = () => {
        // eslint-disable-next-line no-console
        navigate(location.pathname).catch(console.log)
        onClose()
    }

    return <Modal {...newProps}
        open={open}
        onClose={handleClose}
        focusTrapped={false}
        closeOnOverlayClick={newProps?.closeOnOverlayClick}
        closeIcon={<i className='far fa-times-circle'></i>}
        closeOnEsc={newProps.closeOnEsc ?? true}
        classNames={{
            modal: 'simpleModal',
            root: 'simpleModalRoot'
        }}
        animationDuration={200}>
        {children}
        <p className='forPrintOnly'>&copy; Copyright CareSource 2025. All rights reserved.</p>
    </Modal>
}

export default SimpleModal
